import { AuditTrailEnabledField, DEFAULT_ENABLED_AUDIT_TRAIL_FIELD } from "domain/entity/AuditTrailReport/AuditTrailEnabledField";
import { DEFAULT_ENABLED_FINANCIAL_REPORT_FIELD, FinancialReportEnabledField } from "domain/entity/FinancialReport/FinancialReportEnabledField";
import { DEFAULT_ENABLED_GENERAL_REPORT_FIELD, GeneralReportEnabledField } from "domain/entity/GeneralReport/GeneralReportEnabledField";

export const auditTrailReportEnabledField = (reportType: string): AuditTrailEnabledField => {
    let enabledField = { ...DEFAULT_ENABLED_AUDIT_TRAIL_FIELD };
    switch (reportType) {
        case "All Invoice with Invoice Line Details":
            enabledField = {
                ...enabledField,
                docNo: true,
                docDate: true,
            }
            break;
        case "Audit Trail for Company":
            enabledField = {
                ...enabledField,
                companyCode: true,
                transactionDate: true,
            }
            break;
        case "Audit Trail for Customer":
            enabledField = {
                ...enabledField,
                companyCode: true,
                transactionDate: true,
            }
            break;
        case "Audit Trail for Proposal":
            enabledField = {
                ...enabledField,
                companyCode: true,
                transactionDate: true,
                proposalNo: true,
            }
            break;
        case "Credit Invoices":
            enabledField = {
                ...enabledField,
                docDate: true,
            }
            break;
        case "Manual Adjustment of System Charge":
            enabledField = {
                ...enabledField,
                adjustmentDate: true,
                billingType: true,
            }
            break;
        case "Manual Invoice":
            enabledField = {
                ...enabledField,
                docDate: true,
            }
            break;
        default:
            break;
    }
    return enabledField;
}

export const generalReportEnabledField = (reportType: string, operatingUnit: string): GeneralReportEnabledField => {
    let enabledField = { ...DEFAULT_ENABLED_GENERAL_REPORT_FIELD };
    switch (reportType) {
        case "Company Master Report":
            enabledField = {
                ...enabledField,
                companyCode: true,
                activeInd: true,
            }
            break;
        case "Container Un-Billed / Billed THC Report":
            enabledField = {
                ...enabledField,
                vesselArrivalDate: true,
                thc: true,
                shipmentType: true,
                containerSize: true,
                containerStatus: true,
                consortiumCode: true,
                vessleCode: true,
                voyageCode: true,
            }
            break;
        case "Credit Note Summary":
            enabledField = {
                ...enabledField,
                companyCode: true,
                masterCompanyCode: true,
                customerCode: true,
                opsDate: true,
                docDate: true,
            }
            break;
        case "Credit Notes Summary Report":
            enabledField = {
                ...enabledField,
                date: true,
                type: true,
            }
            break;
        case "Criteria Checklist":
            enabledField = {
                ...enabledField,
                criteriaType: true,
                criteriaName: true,
                effectiveDate: true,
                expiryDate: true,
            }
            break;
        case "Dayend Report":
            enabledField = {
                ...enabledField,
                customerCode: true,
                glDate: true,
                docDate: true,
                opsDate: true,
            }
            break;
        case "Exception Report":
            enabledField = {
                ...enabledField,
                exceptionType: true,
            }
            break;
        case "Invoice Register":
            enabledField = {
                ...enabledField,
                ediView: true,
                companyCode: true,
                docNo: true,
                docDate: true,
                chargeType: true,
                masterCompanyCode: true,
            }
            break;
        case "Invoice Summary (Non Operation) Report":
            enabledField = {
                ...enabledField,
                glDate: true,
                docDate: true,
            }
            break;
        case "Invoice Summary (Operation) Report":
            enabledField = {
                ...enabledField,
                glDate: true,
                docDate: true,
            }
            break;
        case "Invoice Summary Report":
            enabledField = {
                ...enabledField,
                download: true,
                date: true,
                consortiumCode: true,
                vessleCode: true,
                voyageCode: true,
                billToCompany: true,
                companyType: true,
            }
            break;
        case "LPA Account Analysis":
            enabledField = {
                ...enabledField,
                lpaCompanyCode: true,
                companyName: true,
                ntnNo: true,
                amount: true,
                transactionType: true,
                transactionDate: true,
                activeInd: true,
            }
            break;
        case "LPA Daily Deposit Report":
            enabledField = {
                ...enabledField,
                lpaCompanyCode: true,
                companyName: true,
                ntnNo: true,
                depositAmount: true,
                transactionDate: true,
                userId: true,
                activeInd: true,
            }
            break;
        case "Let Pass Account Monthly Statement":
            enabledField = {
                ...enabledField,
                date: true,
                companyCode: true,
            }
            break;
        case "Manual/Adjustment Credit Notes Summary":
            enabledField = {
                ...enabledField,
                glDate: true,
                docDate: true,
            }
            break;
        case "Pre-Cool Without Vessel Information":
            enabledField = {
                ...enabledField,
                billToCompany: true,
                chargeOnCompany: true,
                opsDate: true,
            }
            break;
        case "Proposal Master Report":
            enabledField = {
                ...enabledField,
                proposalType: true,
                companyCode: true,
                version: true,
                proposalStatus: true,
                effectiveDate: true,
                proposalNo: true,
            }
            break;
        case "Receival and Delivery Charges Summary":
            enabledField = {
                ...enabledField,
                date: true,
                consortiumCode: true,
                vessleCode: true,
                voyageCode: true,
                companyCode: true,
                companyType: true,
            }
            break;
        case "Summary of Customer Monthly Balance":
            enabledField = {
                ...enabledField,
                docDate: true,
                glDate: true,
            }
            break;
        case "T3 Invoice Revenue Report":
            enabledField = {
                ...enabledField,
                docDate: true,
                docNo: true,
                glDate: true,
                customerCode: true,
            }
            break;
        case "Tariff Adjustment Report":
            enabledField = {
                ...enabledField,
                proposalFromTo: true,
            }
            break;
        case "Tariff item Mapping List":
            enabledField = {
                ...enabledField,
                tariff: true,
                activeInd: true,
            }
            break;
        case "Throughput By Line Report":
            enabledField = {
                ...enabledField,
                view: true,
                masterChargeOnCompany: true,
                chargeOnCompany: true,
                operatingTml: true,
                serviceCode: true,
                opsDate: true,
            }
            break;
        case "Throughput by Company":
            enabledField = {
                ...enabledField,
                view: true,
                companyCode: true,
                operatingTml: true,
                serviceCode: true,
                tariff: true,
                opsDate: true,
            }
            break;
        case "Volume Discount Report":
            enabledField = {
                ...enabledField,
                date: true,
                consortiumCode: true,
                companyCode: true,
                referenceDate: true,
            }
            break;
        case "Waiver Report":
            enabledField = {
                ...enabledField,
                approvedDate: true,
            }
            break;
        //OICT/AQCT/RSCT
        case "Billing Statistics Report":
            enabledField = {
                ...enabledField,
                settlementDate: true,
            }
            break;
        case "CC Invoice/Credit Note Summary Report":
            enabledField = {
                ...enabledField,
                dateTimeFromTo: true,
                billToCompany: true,
                opsLine: true,
                type: true,
            }
            break;
        case "Cash Reconciliation":
            enabledField = {
                ...enabledField,
                collDate: true,
                cashier: true,
            }
            break;
        case "Full Container Summary Report":
            enabledField = {
                ...enabledField,
                opsDate: true,
                chargeOnCompany: true,
            }
            break;
        case "Full Pool Container List Report":
            enabledField = {
                ...enabledField,
                yearInput: true,
                month: true,
                chargeOnCompany: true,
            }
            break;
        case "Revenue Analysis Per Shipping Line Per Tariff Item":
            enabledField = {
                ...enabledField,
                date: true,
                shippingLine: true,
                tariffCode: true,
            }
            break;
        default:
            break;
    }
    if (operatingUnit === "SAPT" || operatingUnit === "KICT") {
        if (reportType === "Sales Tax Report") {
            enabledField = {
                ...enabledField,
                date: true,
                shipperConsignee: true,
                shipperConsigneeCompanyName: true,
                subType: true,
                billToCompany: true,
                docType: true,
            }
        }
        if (reportType === "Empty Pool Container List Report") {
            enabledField = {
                ...enabledField,
                opsLine: true,
                opsDate: true,
            }
        }
        if (reportType === "Empty Container Summary Report") {
            enabledField = {
                ...enabledField,
                opsLine: true,
                opsDate: true,
            }
        }
    } else {
        if (reportType === "Empty Container Summary Report") {
            enabledField = {
                ...enabledField,
                opsDate: true,
                chargeOnCompany: true,
            }
        }
        if (reportType === "Empty Pool Container List Report") {
            enabledField = {
                ...enabledField,
                yearInput: true,
                month: true,
                chargeOnCompany: true,
            }
        }
        if (reportType === "Sales Tax Report") {
            enabledField = {
                ...enabledField,
                date: true,
                companyType: true,
            }
        }
    }
    return enabledField;
}

export const financialReportEnabledField = (reportType: string): FinancialReportEnabledField => {
    let enabledField = { ...DEFAULT_ENABLED_FINANCIAL_REPORT_FIELD };
    switch (reportType) {
        case "Billing By Client and Concept":
            enabledField = {
                ...enabledField,
                docDate: true,
                glDate: true,
            }
            break;
        case "Billing Comparative":
            enabledField = {
                ...enabledField,
                docDate: true,
                glDate: true,
            }
            break;
        case "Comparative between TEUs":
            enabledField = {
                ...enabledField,
                p1OperationDate: true,
                p2OperationDate: true,
            }
            break;
        case "Movement List":
            enabledField = {
                ...enabledField,
                soa: true,
                vslOperationDate: true,
            }
            break;
        case "Movements Per Line":
            enabledField = {
                ...enabledField,
                vslOperationDate: true,
            }
            break;
        case "Movements Per Ship Owner":
            enabledField = {
                ...enabledField,
                vslOperationDate: true,
            }
            break;
        case "Output Statistics":
            enabledField = {
                ...enabledField,
                etd: true,
            }
            break;
        case "Price Changes List":
            enabledField = {
                ...enabledField,
                chargeOnCompany: true,
                effectiveDate: true,
            }
            break;
        case "Rail Movement":
            enabledField = {
                ...enabledField,
                operationDate: true,
            }
            break;
        case "Revenue By Tariff And Customer":
            enabledField = {
                ...enabledField,
                billToCompany: true,
                yearMonth: true,
                printer: true,
            }
            break;
        case "TEUs Billed":
            enabledField = {
                ...enabledField,
                docDate: true,
                glDate: true,
            }
            break;
        case "Vessel movements report":
            enabledField = {
                ...enabledField,
                vslOperationDate: true,
            }
            break;
        case "Storage and Reefer Charge Simulation Report":
            enabledField = {
                ...enabledField,
                simulationDate: true,
            }
            break;
        default:
            break;
    }
    return enabledField;
}